import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { IoClose } from "react-icons/io5";
import { API } from './constant';
import { toast, ToastContainer } from 'react-toastify';

const User = () => {
  const [showUserModal, setShowUserModal] = useState(false);
  const [userList, setUserList] = useState([])
  const [editingUser, seteditingUser] = useState(null)
  const [filterUser, setFilterUser] = useState("")

  // const handleUserSubmit = (data) => {
  //   console.log("User Data:", data);
  // };


  const fetchUsers = async () => {
    try {
      const response = await axios.get(`${API}/register/get-all`)
      console.log(response)
      setUserList(response.data)
    } catch (error) {
      console.log("Error fetching user details", error)
    }
  }

  useEffect(() => {
    fetchUsers()
  }, [])

  const handleUserSubmit = async (data) => {
    try {
      const payload = { ...data }
      if (editingUser && !payload.password) {
        delete payload.password
      }

      if (editingUser) {
        await axios.put(`${API}/register/update-user/${editingUser._id}`, payload)
      } else {
        await axios.post(`${API}/register/create-new`, payload)
      }
      fetchUsers()
      setShowUserModal(false)
      seteditingUser(null)

    } catch (error) {
      // console.log("Error saving user details", error)
      if (error.response) {
        toast.warning(error.response.data.message || "Something went wrong");
      } else if (error.request) {
        toast.warning("Server not responding. Please try again.");
      } else {
        toast.warning("Unexpected error occurred.");
      }
    }
  }

  const handleEdit = (user) => {
    seteditingUser(user)
    setShowUserModal(true)
  }


  const handleCloseModal = () => {
    setShowUserModal(false)
    seteditingUser(null)
  }


  const handleDelete = async (id) => {
    try {
      if (!window.confirm("Are you sure you want to delete this user?")) {
        return
      }
      await axios.delete(`${API}/register/delete-user/${id}`)
      fetchUsers()
    } catch (error) {
      console.log("Error deleting user", error)
    }
  }


  const filteredUsers = userList.filter((item) => {
    const search = filterUser.toLowerCase();

    return (
      item.name?.toLowerCase().includes(search) ||
      item.email?.toLowerCase().includes(search) ||
      item.department?.toLowerCase().includes(search) ||
      item.role?.toLowerCase().includes(search) ||
      item.designation?.toLowerCase().includes(search)
    );
  });
  return (
    <div>
      <div>
        <div className='card_button_container'>
          <div className='button_search DFJCBAIC marginB10'>
            <div></div>
            <div className='DFJCCAIC gap10'>
              <div>
                <button onClick={() => setShowUserModal(true)} className='add_button'>Create User</button>
              </div>
              <div>
                <input value={filterUser} onChange={(e) => setFilterUser(e.target.value)} className='search_box' type="search" placeholder='Filter' />
              </div>
            </div>
          </div>

          <hr />

          {/* =====cards start====  */}
          <div className='table_container width100'>
            <table className="mac_table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Department</th>
                  <th>Role</th>
                  <th>Designation</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {filteredUsers && filteredUsers.map((item) => (
                  <tr key={item._id}>
                    <td>{item.name}</td>
                    <td>{item.email}</td>
                    <td>{item.department}</td>
                    <td>{item.role}</td>
                    <td>{item.designation}</td>
                    <td>
                      <button onClick={() => handleEdit(item)} style={{ marginRight: "10px", cursor: "pointer" }}>Edit</button>
                      <button onClick={() => handleDelete(item._id)} style={{ cursor: "pointer", color: "red" }}>Delete</button>
                    </td>
                  </tr>
                ))}
                {/* {userList.length === 0 && (
                  <tr>
                    <td colSpan="5" style={{ textAlign: "center" }}>No vendor details found.</td>
                  </tr>
                )} */}
                {filteredUsers.length === 0 && (
                  <tr>
                    <td colSpan="6" style={{ textAlign: "center" }}>
                      No users found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

          </div>
          {/* =====cards end====  */}

          {showUserModal && (
            <AddUserModal
              onClose={handleCloseModal}
              onSubmit={handleUserSubmit}
              initialData={editingUser}
            />
          )}


        </div>
      </div>
    </div>

  )
}


const AddUserModal = ({ onClose, onSubmit, initialData }) => {
  const [masters, setMasters] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    // password: "",
    // location: "",
    locations: [],
    phone: "",
    designation: "",
    department: "",
    role: "",
    restrictedSoftware: []
  });


  useEffect(() => {
    if (initialData) {
      setFormData({
        name: initialData.name || "",
        email: initialData.email || "",
        password: "",
        // location: initialData.location || "",
        locations: initialData.locations || [],
        phone: initialData.phone || "",
        designation: initialData.designation || "",
        department: initialData.department || "",
        role: initialData.role || "",
        restrictedSoftware: initialData.restrictedSoftware || []
      })
    } else {
      setFormData({
        name: "",
        email: "",
        password: "",
        locations: [],
        phone: "",
        designation: "",
        department: "",
        role: "",
        restrictedSoftware: []
      })
    }
  }, [initialData])

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };



  const [softwareOptions, setSoftwareOptions] = useState([]);

  const fetchMasters = async () => {
    try {
      const response = await axios.get(`${API}/masters?type=School Location`);
      setMasters(response.data);
    } catch (error) {
      console.error("Error fetching masters:", error);
      if (error.response?.status === 401 || error.response?.data?.message === "Invalid Token") {
        window.location.href = "/";
      } else {
        toast.error("Failed to load master data.");
      }
    }
  };

  const fetchSoftware = async () => {
    try {
      const response = await axios.get(`${API}/all-software`);
      setSoftwareOptions(response.data);
    } catch (error) {
      console.error("Error fetching software:", error);
    }
  };

  useEffect(() => {
    fetchMasters();
    fetchSoftware();
  }, []);

  return (
    <div>
      <ToastContainer />
      <div className="fixed inset-0 bg-black/30 flex justify-center items-center z-50">

        <div className="bg-white w-[520px] rounded-xl shadow-lg overflow-hidden">

          {/* Header */}
          <div className="flex justify-between items-center px-4 py-3 border-b bg-[#f5f5f7]">
            <h2 className="text-sm font-medium">{initialData ? "Edit User" : "Add User"}</h2>
            <IoClose size={20} className="cursor-pointer" onClick={onClose} />
          </div>

          {/* Body */}
          <form
            onSubmit={handleSubmit}
            className="p-4 space-y-3 text-sm max-h-[70vh] overflow-y-auto"
          >
            <div className="form_group">
              <label >Name</label>
              <input
                type="text"
                name="name"
                placeholder="Name"
                value={formData.name}
                onChange={handleChange}
                className="w-full border rounded-md px-3 py-2"
                required
              />
            </div>

            <div className="form_group">
              <label >Email</label>
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                className="w-full border rounded-md px-3 py-2"
                required
              />
            </div>


            {/* <div className="form_group">
              <label >Password</label>
              <input
                type="password"
                name="password"
                placeholder="Password"
                value={formData.password}
                onChange={handleChange}
                className="w-full border rounded-md px-3 py-2"
                required={!initialData}
              />
            </div> */}


            {/* <div className="form_group">
              <label >Location</label>
          
              <select name="location" value={formData.location} onChange={handleChange }>
                <option value="">--Select Location--</option>
                {masters && masters.map((item, index) =>
                (
                  <>
                    <option value={item.value}>{item.value}</option>
                  </>
                ))}
              </select>
            </div> */}

            <div className="form_group">
              <label>Locations</label>

              {/* Search */}
              <input
                type="text"
                placeholder="Search locations..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full border rounded-md px-3 py-2 mb-2"
              />

              {/* Options */}
              <div className="border rounded-md px-3 py-2 max-h-40 overflow-y-auto w-full space-y-2 bg-white">
                {masters
                  .filter(item =>
                    item.value.toLowerCase().includes(searchTerm.toLowerCase())
                  )
                  .map((item) => (
                    <label key={item.value} className="flex items-center gap-2 text-sm cursor-pointer">
                      <input
                        type="checkbox"
                        value={item.value}
                        checked={formData.locations.includes(item.value)}
                        onChange={(e) => {
                          const selected = formData.locations;

                          if (e.target.checked) {
                            setFormData({
                              ...formData,
                              locations: [...selected, item.value]
                            });
                          } else {
                            setFormData({
                              ...formData,
                              locations: selected.filter(loc => loc !== item.value)
                            });
                          }
                        }}
                      />
                      {item.value}
                    </label>
                  ))}

                {masters.length === 0 && (
                  <span className="text-gray-400 text-sm">No locations found.</span>
                )}
              </div>
            </div>

            <div className="form_group">
              <label >Phone</label>
              <input
                type="tel"
                name="phone"
                placeholder="Phone"
                value={formData.phone}
                onChange={handleChange}
                className="w-full border rounded-md px-3 py-2"
              />
            </div>
            <div className="form_group">
              <label >Role</label>
              <select name="role" value={formData.role} onChange={handleChange}>
                <option value="">-Select user role-</option>
                <option value="SUPER ADMIN">SUPER ADMIN</option>
                <option value="ADMIN">ADMIN</option>
                <option value="USER">USER</option>
              </select>
            </div>

            {/* <div className="form_group">
              <label>Restricted Applications</label>
              <input
                type="text"
                placeholder="Search applications..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full border rounded-md px-3 py-2 mb-2"
              />
              <div className="border rounded-md px-3 py-2 max-h-40 overflow-y-auto w-full space-y-2 bg-white">
                {!formData.location ? (
                  <span className="text-gray-400 text-sm">Please select a location first.</span>
                ) : (
                  <>
                    {softwareOptions
                      .filter(app =>
                        app.schoolLocation &&
                        Array.isArray(app.schoolLocation) &&
                        app.schoolLocation.includes(formData.location) &&
                        app.softwareName &&
                        app.softwareName.toLowerCase().includes(searchTerm.toLowerCase())
                      )
                      .slice(0, 3)
                      .map(app => (
                        <label key={app._id} className="flex items-center gap-2 text-sm cursor-pointer">
                          <input
                            type="checkbox"
                            value={app._id}
                            checked={formData.restrictedSoftware && formData.restrictedSoftware.includes(app._id)}
                            onChange={(e) => {
                              const currentRestricted = formData.restrictedSoftware || [];
                              if (e.target.checked) {
                                setFormData({ ...formData, restrictedSoftware: [...currentRestricted, app._id] });
                              } else {
                                setFormData({ ...formData, restrictedSoftware: currentRestricted.filter(id => id !== app._id) });
                              }
                            }}
                          />
                          {app.softwareName}
                        </label>
                      ))}
                    {softwareOptions.filter(app =>
                      app.schoolLocation &&
                      Array.isArray(app.schoolLocation) &&
                      app.schoolLocation.includes(formData.location) &&
                      app.softwareName &&
                      app.softwareName.toLowerCase().includes(searchTerm.toLowerCase())
                    ).length === 0 && <span className="text-gray-400 text-sm">No applications found.</span>}
                  </>
                )}
              </div>
            </div> */}

            <div className="form_group">
              <label>Restricted Applications</label>

              <input
                type="text"
                placeholder="Search applications..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full border rounded-md px-3 py-2 mb-2"
              />

              <div className="border rounded-md px-3 py-2 max-h-40 overflow-y-auto w-full space-y-2 bg-white">

                {/* ❌ Fix: check locations array */}
                {!formData.locations || formData.locations.length === 0 ? (
                  <span className="text-gray-400 text-sm">
                    Please select at least one location first.
                  </span>
                ) : (
                  (() => {
                    // ✅ Single filter (clean + reusable)
                    const filteredApps = softwareOptions.filter(app =>
                      app.schoolLocation &&
                      Array.isArray(app.schoolLocation) &&
                      formData.locations.some(loc =>
                        app.schoolLocation.includes(loc)
                      ) &&
                      app.softwareName &&
                      app.softwareName.toLowerCase().includes(searchTerm.toLowerCase())
                    );

                    return (
                      <>
                        {/* ✅ Show apps */}
                        {filteredApps.slice(0, 10).map(app => (
                          <label
                            key={app._id}
                            className="flex items-center gap-2 text-sm cursor-pointer"
                          >
                            <input
                              type="checkbox"
                              value={app._id}
                              checked={formData.restrictedSoftware?.includes(app._id)}
                              onChange={(e) => {
                                const currentRestricted = formData.restrictedSoftware || [];

                                if (e.target.checked) {
                                  setFormData({
                                    ...formData,
                                    restrictedSoftware: [...currentRestricted, app._id]
                                  });
                                } else {
                                  setFormData({
                                    ...formData,
                                    restrictedSoftware: currentRestricted.filter(
                                      id => id !== app._id
                                    )
                                  });
                                }
                              }}
                            />
                            {app.softwareName}
                          </label>
                        ))}

                        {/* ✅ Empty state */}
                        {filteredApps.length === 0 && (
                          <span className="text-gray-400 text-sm">
                            No applications found.
                          </span>
                        )}
                      </>
                    );
                  })()
                )}
              </div>
            </div>

            <div className="form_group">
              <label >Designation</label>
              <input
                type="text"
                name="designation"
                placeholder="Designation"
                value={formData.designation}
                onChange={handleChange}
                className="w-full border rounded-md px-3 py-2"
              />
            </div>

            <div className="form_group">
              <label >Department</label>
              <input
                type="text"
                name="department"
                placeholder="Department"
                value={formData.department}
                onChange={handleChange}
                className="w-full border rounded-md px-3 py-2"
              />
            </div>

            {/* Footer */}
            <div className="flex justify-end gap-2 pt-2">
              <button
                type="button"
                onClick={onClose}
                className="white_button"
              >
                Cancel
              </button>

              <button
                type="submit"
                className="add_button"
              >
                {initialData ? "Update" : "Save"}
              </button>
            </div>

          </form>
        </div>
      </div>
    </div>
  );
};


export default User
